'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('..');

var _2 = _interopRequireDefault(_);

var _LastPage = require('material-ui-icons/LastPage');

var _LastPage2 = _interopRequireDefault(_LastPage);

var _3 = require('../../../..');

var _4 = _interopRequireDefault(_3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Pagination = (_temp = _class = function (_EditorComponent) {
  _inherits(Pagination, _EditorComponent);

  function Pagination() {
    _classCallCheck(this, Pagination);

    return _possibleConstructorReturn(this, _EditorComponent.apply(this, arguments));
  }

  Pagination.prototype.renderPanelView = function renderPanelView(content) {
    var _getEditorContext = this.getEditorContext(),
        classes = _getEditorContext.classes;

    return _EditorComponent.prototype.renderPanelView.call(this, content || _react2.default.createElement('div', {
      className: classes.panelButton
    }, _react2.default.createElement(_LastPage2.default, null), ' Pagination'));
  };

  Pagination.prototype.canBeChild = function canBeChild(child) {
    return false;
  };

  Pagination.prototype.canBeParent = function canBeParent(parent) {
    var can = false; // return false;

    if (_EditorComponent.prototype.canBeParent.call(this, parent)) {
      while (parent) {
        if (parent instanceof _2.default) {
          can = true;
          break;
        }

        parent = parent.props.parent;
      }
    }

    return can;
  };

  Pagination.prototype.renderChildren = function renderChildren() {
    var _this2 = this;

    var PrismaCmsPagination = this.context.Pagination;
    return _react2.default.createElement(_react.Fragment, null, _react2.default.createElement(_.ConnectorContext.Consumer, null, function (context) {
      var data = context.data,
          _context$pageVariable = context.pageVariable,
          pageVariable = _context$pageVariable === undefined ? "page" : _context$pageVariable,
          other = _objectWithoutProperties(context, ['data', 'pageVariable']);

      if (!data) {
        return;
      }

      var objectsConnection = data.objectsConnection,
          variables = data.variables;

      if (!objectsConnection) {
        return null;
      }

      var total = objectsConnection.aggregate.count;

      var _ref = variables || {},
          limit = _ref.first;

      var uri = _this2.context.uri;

      var _uri$query = uri.query(true),
          page = _uri$query[pageVariable];

      page = parseInt(page) || 0;
      return _react2.default.createElement(PrismaCmsPagination, {
        pageVariable: pageVariable,
        limit: limit,
        total: total,
        page: page || 1
      });
      {
        /* if (!object) {
          return null;
         }
         return <PrismaCmsPagination
          user={object}
         /> */
      }
    }), _EditorComponent.prototype.renderChildren.call(this));
  };

  return Pagination;
}(_4.default), _class.Name = "Pagination", _class.defaultProps = _extends({}, _4.default.defaultProps, {
  hide_wrapper_in_default_mode: true
}), _temp);
exports.default = Pagination;
module.exports = exports['default'];